import type { EpisodeCategory } from '@common/enums';
import type { IServiceEmployment } from '@frontend/components/interfaces/serviceEmployment';
import { ServiceEmploymentSettings } from './ServiceEmploymentSettings';

interface ServiceEmploymentsGroupSettingsProps {
    employmentId: string;
    episodeCategory: EpisodeCategory;
    organizationId: string;
    reloadServiceRight: () => Promise<void>;
    serviceEmploymentRights: IServiceEmployment[];
}

export function ServiceEmploymentsGroupSettings(props: ServiceEmploymentsGroupSettingsProps) {
    const { serviceEmploymentRights } = props;

    return <>{renderAllServiceGroupSettings()}</>;

    function renderAllServiceGroupSettings() {
        if (!serviceEmploymentRights.length) {
            return;
        }

        return serviceEmploymentRights.map((serviceGroupSetting) => {
            return (
                <ServiceEmploymentSettings
                    key={`serviceEmployment-${serviceGroupSetting.id}`}
                    serviceRight={serviceGroupSetting}
                    {...props}
                />
            );
        });
    }
}
